import { Observable } from 'rxjs';

import { Project, ProjectCreateParams, ProjectQueryParams, ProjectUpdateParams, ReportCreateParams } from '../models/project.model';
import { ListResponse } from '../models/utility.model';

export abstract class ProjectGateway {
  abstract listProjects(params: ProjectQueryParams): Observable<ListResponse<Project>>;
  abstract createProject(params: ProjectCreateParams): Observable<Project>;
  abstract updateProject(projectId: string, params: ProjectUpdateParams): Observable<Project>;
  abstract deleteProject(projectId: string): Observable<void>;
  abstract getConsentForm(projectId: string, consentId: string): Observable<{ url: string }>;
  abstract createReport(projectId: string, params: ReportCreateParams): Observable<Project>;
}
